export default __webpack_public_path__ + "static/media/zap-white.9ef104ef.svg";